import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlagPositiveResult = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m10 1.875c-1.60697 0-3.17786.47652-4.514 1.36931-1.33615.89279-2.37756 2.16174-2.99252 3.64639s-.77586 3.1183-.46236 4.6944c.31351 1.5761 1.08734 3.0238 2.22364 4.1601s2.58404 1.9102 4.16014 2.2237c1.57609.3135 3.2098.1526 4.6944-.4624 1.4847-.6149 2.7536-1.6563 3.6464-2.9925.8928-1.3361 1.3693-2.907 1.3693-4.514-.0027-2.15406-.8596-4.21912-2.3827-5.74227-1.5232-1.52316-3.5882-2.38004-5.7423-2.38273zm3.125 8.75h-2.5v2.5c0 .1658-.0658.3247-.1831.4419-.1172.1173-.2761.1831-.4419.1831-.16576 0-.32473-.0658-.44194-.1831-.11721-.1172-.18306-.2761-.18306-.4419v-2.5h-2.5c-.16576 0-.32473-.0658-.44194-.1831-.11721-.1172-.18306-.2761-.18306-.4419 0-.16576.06585-.32473.18306-.44194s.27618-.18306.44194-.18306h2.5v-2.5c0-.16576.06585-.32473.18306-.44194s.27618-.18306.44194-.18306c.1658 0 .3247.06585.4419.18306.1173.11721.1831.27618.1831.44194v2.5h2.5c.1658 0 .3247.06585.4419.18306.1173.11721.1831.27618.1831.44194 0 .1658-.0658.3247-.1831.4419-.1172.1173-.2761.1831-.4419.1831z",
		fill: "current"
	})
});
export default SvgFlagPositiveResult;
